export const sortObjectsWithFieldByAlphabet = (projects, sortDescending, fieldName) => {
	return projects.sort((objA, objB) => sortDescending ? objA[fieldName].localeCompare(objB[fieldName]) : objB[fieldName].localeCompare(objA[fieldName]));
};

export const sortProjectsByStartDate = (projects, sortDescending) => {
	return projects.sort((projA, projB) => sortDescending ?
		new Date(projA.startDate) - new Date(projB.startDate)
		: new Date(projB.startDate) - new Date(projA.startDate))
};

export const filterProjectsWithDateRange = (projects, fromDate, toDate) => {
	return projects.filter((proj) => {
		const itemDate = new Date(proj.startDate);

		const isAfterFrom = !fromDate || itemDate >= fromDate;
		const isBeforeTo = !toDate || itemDate <= toDate;

		return isAfterFrom && isBeforeTo;
	});
};

export const filterProjectsBySelectedSkills = (projects, selectedSkills) => {
	return projects.filter(({ skills }) => selectedSkills.filter(({ id }) => skills.indexOf(id) !== -1).length === selectedSkills.length);
}

export const filterProjectsBySkillId = (projects, skillId) => {
	return projects.filter(({ skills }) => skills.includes(Number(skillId)));
};

export const sortEmployeeBySkillLevel = (employees, sortDescending = false) => {
	return employees.sort((employeeA, employeeB) => sortDescending ? employeeA.level - employeeB.level : employeeB.level - employeeA.level);
}


// WEBPACK FOOTER //
// ./src/service/filters.js